import { render } from "./IconClose.vue?vue&type=template&id=4bd65c27"
const script = {}
script.render = render

export default script